<template>
  <v-row no-gutters :style="styles">
    <v-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :cols="12">
      <div
        class="text-h6 px-5"
        style="color:black;"
        :id="id">
        {{headerTitle}}
      </div>
      <v-divider class="py-2 d-none d-sm-block"></v-divider>
      <v-divider class="block-sm-and-down hidden-md-and-up"></v-divider>
    </v-col>
    <v-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :cols="12">
      <v-row no-gutters class="d-none d-sm-block">
        <v-col :cols="6">
          <div class="switch-space">
            <dd-switch
              class="switch-line-divider pt-4 px-2 pb-4"
              :label="switchLabel"
              v-bind="computedProps"
              v-on="computedListeners"
            />
          </div>
          <v-divider class="py-2"></v-divider>
        </v-col>
        <v-col :cols="6" class="">
          <div class="adjust-space">
            <span class="text-subtitle-2">{{caption}}</span>
          </div>
          <v-divider class="py-2"></v-divider>
        </v-col>
      </v-row>
      <v-row no-gutters class="pb-1 block-sm-and-down hidden-md-and-up">
        <dd-switch
          :label="switchLabel"
          v-bind="computedProps"
          v-on="computedListeners"
        />
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import inputMixin from '@/mixins/inputMixins'
import DdSwitch from '@/components/DdSwitch'

/**
 * @file DDv2用スイッチ付きサブヘッダ
 * @namespace components
 */

/**
 * @vue-prop {String} [id=''] - ID
 * @vue-prop {String} [headerTitle=''] - サブヘッダータイトル
 * @vue-prop {String} [switchLabel=''] - スイッチラベル
 * @vue-prop {String} [caption=''] - スイッチ横キャプション
 * @see components.DdSwitch
 * @example
 * <dd-arrow-header-with-switch
 *   v-model="checkValue"
 *   id="string"
 *   headerTitle="string"
 *   switchLabel="string"
 *   caption="string"
 * />
 */
export default {
  name: 'DdSubHeaderWithSwitch',
  components: {
    DdSwitch
  },
  extends: DdSwitch,
  mixins: [inputMixin],
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * 表示ヘッダータイトル
     */
    headerTitle: {
      type: String,
      default: ''
    },
    /**
     * スイッチのラベル
     */
    switchLabel: {
      type: String,
      default: ''
    },
    /**
     * スイッチ横のキャプション
     */
    caption: {
      type: String,
      default: ''
    },
    borderLeftColor: {
      type: String,
      default: '#2D71BF'
    },
    backgroundColor: {
      type: String,
      default: '#E9F1F7'
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  watch: {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    // バインドするスタイルを生成
    styles () {
      return {
        '--bdlcolor': this.borderLeftColor,
        '--bgcolor': this.backgroundColor
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.text-h6 {
  border-left: 6px solid var(--bdlcolor) !important;
  background-color: var(--bgcolor) !important;
  color: #1F2B38 !important;
  font-size: 1.125rem !important;
  font-weight: bold !important;
  letter-spacing: 0px !important;
  margin-top: 4px !important;
  padding: .1em .5em !important;
}
.switch-space {
  background-color: var(--bgcolor) !important;
}
.switch-line-divider {
  margin-top:3px !important;
  padding-top:5px !important;
}
.adjust-space {
  background-color: var(--bgcolor) !important;
  margin-top:3px !important;
  padding-top: 14px;
}
.text-subtitle-2 {
  color: #333; /*文字の色を変更*/
  padding: .1em .5em;
  margin-top: 18px;
}
</style>
